import { FilterModel } from './../../_models/reports/ProductWiseBranchRevenueModel';
import { Http } from '@angular/http';
import { Router, NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseProvider } from '../BaseProvider';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class ReportsService extends BaseProvider {

    leadFunnelUrl = 'reports/leadFunnel?startDate=2001-01-01&endDate=2051-01-01';
    orderStatusSummaryUrl = 'reports/orderStatusSummary';
    bankProcessingStatusUrl = 'reports/bankProcessingStatus';
    processingSummaryUrl = 'reports/processingSummery';
    orderStatusSummaryByPartnerUrl = 'reports/partnerOrdersSummary';

    orderRevenueUrl = 'reports/partnerOrderWiseRevenueByBranchByDate';

    constructor(private router: Router, private http: Http, private _gs: GlobalService) {
        super(http);
    }
    getOutstandingAmount(partnerID) {
        // let partnerId = this._gs.currentUser.partner.id;
        return this.makeGetCall("partners/outstanding/" + partnerID);
    }

    getLeadFunnel(startDate, endDate) {
        // let partnerId = this._gs.currentUser.partner.id;
        return this.makeGetCall("reports/leadSummary" + "?startDate=" + startDate + "&endDate=" + endDate);
    }
    getLeadFunnelWithPartnerId(startDate, endDate, partnerId) {
        if (partnerId != null) {
        } else {
            let partnerId = this._gs.currentUser.partner.id;

        }
        // let partnerId = this._gs.currentUser.partner.id;
        return this.makeGetCall("reports/leadSummary" + "?partnerId=" + partnerId + "&startDate=" + startDate + "&endDate=" + endDate);
    }
    getLeadFunnelWithBranch(startDate, endDate, branchId) {
        //let partnerId = this._gs.currentUser.partner.id;
        return this.makeGetCall("reports/leadSummary" + "?startDate=" + startDate + "&endDate=" + endDate + "&branchId=" + branchId);
    }

    getOrderStatusSummary(startDate, endDate) {
        return this.makeGetCall(this.orderStatusSummaryUrl + "?startDate=" + startDate + "&endDate=" + endDate);
    }
    getOrderStatusSummaryWithPartner(startDate, endDate, partnerId, branchId) {
        //  let partnerId = this._gs.currentUser.partner.id;


        if (branchId != -1) {
            return this.makeGetCall(this.orderStatusSummaryUrl +
                "?partnerId=" + partnerId + "&startDate=" +
                startDate + "&endDate=" + endDate + "&branchId=" + branchId);

        } else {
            return this.makeGetCall(this.orderStatusSummaryUrl +
                "?partnerId=" + partnerId + "&startDate=" +
                startDate + "&endDate=" + endDate);
        }

    }
    getOrderStatusSummaryWithBranch(startDate, endDate, branchId) {
        return this.makeGetCall(this.orderStatusSummaryUrl + "?startDate=" + startDate + "&endDate=" + endDate + "&branchId=" + branchId);
    }

    getOrderStatusSummaryByPartner(startDate, endDate) {
        let partnerId = this._gs.currentUser.partner.id;
        return this.makeGetCall(this.orderStatusSummaryByPartnerUrl + "?partnerId=" + partnerId + "&startDate=" + startDate + "&endDate=" + endDate);
    }
    getOrderStatusSummaryByPartnerWithBranch(startDate, endDate, branchId) {
        return this.makeGetCall(this.orderStatusSummaryByPartnerUrl + "?startDate=" + startDate + "&endDate=" + endDate + "&branchId=" + branchId);
    }
    getOrderWiseRevenueSummary(startDate, endDate, status, partnerId) {
        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }

        return this.makeGetCall(this.orderRevenueUrl + "?partnerId=" + partnerId + "&startDate=" + startDate + "&endDate=" + endDate + "&orderStatus=" + status + '&branchId=' + this._gs.currentUser.branch.id);


    }
    getOrderWiseRevenueSummaryWithPartner(startDate, endDate, status, partnerId, branchId) {

        if (partnerId == null) {
            partnerId = this._gs.currentUser.partner.id;
        }
        if (partnerId == -1) {
            partnerId = this._gs.currentUser.partner.id;
        }

        if (branchId != -1) {
            return this.makeGetCall(this.orderRevenueUrl + "?partnerId=" +
                partnerId + "&startDate=" + startDate + "&endDate=" +
                endDate + '&branchId=' + branchId + "&orderStatus=" + status);

        } else if (status != -1) {
            return this.makeGetCall(this.orderRevenueUrl +
                "?partnerId=" + partnerId + "&startDate=" +
                startDate + "&endDate=" + endDate + "&orderStatus=" +
                status);

        } else {
            return this.makeGetCall(this.orderRevenueUrl +
                "?partnerId=" + partnerId + "&startDate=" +
                startDate + "&endDate=" + endDate);
        }

    }

    getBankProcessingStatus() {
        return this.makeGetCall(this.bankProcessingStatusUrl);
    }

    getProcessingSummary() {
        return this.makeGetCall(this.processingSummaryUrl);
    }
    gotoNextPage(filterModel: FilterModel) { // TODO: to be removed from here
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'filterModel': filterModel
            }
        };
        this.router.navigate([filterModel.path], navigationExtras);
    }
    getIpDetails() {
        return this.http.get('https://api.ipify.org?format=json');
    }

    // Same insights report as the partner portal; partnerId is sent only when a partner is selected
    getPartnerInsights(reportPeriod: string, partnerId?: string) {
        return this.makeGetCall('reports/partnerInsights?period=' + reportPeriod +
            (partnerId ? '&partnerId=' + partnerId : ''));
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/reports/reports.service.ts